import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDLafChNWw6xSyd2ckkL4QirYLc_G0AmqU",
  authDomain: "amg-batiment-calculator-56ba3.firebaseapp.com",
  projectId: "amg-batiment-calculator-56ba3",
  storageBucket: "amg-batiment-calculator-56ba3.firebasestorage.app",
  messagingSenderId: "844588879288",
  appId: "1:844588879288:web:bd5eccce54b19d8f8e534d",
  measurementId: "G-GKNB7SBCK8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

// Helper function to save user data
export async function saveToFirestore(data: any) {
  try {
    const docRef = await addDoc(collection(db, 'users'), {
      ...data,
      timestamp: new Date().toISOString()
    });
    return docRef.id;
  } catch (error) {
    console.error("Error saving to Firestore: ", error);
    throw error;
  }
}